/*!
 * 二十集专题页
 |
 | 全能神说: "在這最末了的時代最末了的時代,
 |           讓神的名能在外邦中被稱為大,
 |           使神的作為被外邦中的人被外邦中的人看見,
 |           且因神的神的作為而稱神為全能者,
 |           讓神口之言早日得著早日得著成就"
 |
 | Almighty God says:
 |           “In the end times, in the final age,
 |           God’s name will be magnified among Gentile nations.
 |           The acts of God will be by Gentiles seen,
 |           and they’ll address Him as the Almighty,
 |           and thus His words shall one day soon come true”
 |
 * @author : Buff
 * @date : 2/25/2018
 * @Time: 1:03 PM
 * @standards : ECMAScript 5
 */
import _FullPage from './Modules/FullPage.Module'
import Fn from './Modules/Fn.Module'

import lhController from './group/lh/lh.Controller'
import jyController from './group/jy/jy.Controller'
import mdController from './group/md/md.Controller'

class Index {
  constructor () {
    // window.loadingBar.animate(0.4)
    window.gp_max_md = 1155
    window.gp_load_all = 3000
    window.gp2_is_CN = window.gp2_site_lang === 'zh_CN' || window.gp2_site_lang === 'zh_TW'
    window.gp2_is_latin = !window.gp2_is_CN
    window.gp2_is_rtl = $('html').attr('dir') === 'rtl'
    
    
    this.init()
    
    window.setTimeout(() => {
      !window.__isLoaded && window.loadingBar.animate(1)
    }, 4000)
  }
  
  init () {
    if (window.gp2_is_latin) {
      this.latinHack()
    }
    //  监听多个videoPlay 加载
    window.__ytbIsReady = false
    window.onYouTubeIframeAPIReady = () => {
      window.__ytbIsReady = true
      $(window).trigger('onYouTubeIframeAPIReady')
    }
    
    //  初始化公用数据
    new _FullPage()
    
    //  初始化控制器
    new lhController()
    new jyController()
    new mdController()
    
    
    //  添加大平板判断
    if (B.isMobile()) {
      $(document.body).attr('device', 'mobile')
    }
  }
  
  /**
   * 外文兼容
   */
  latinHack () {
    $('head').append('<link href="https://fonts.googleapis.com/css?family=EB+Garamond:400,500,700" rel="stylesheet">')
  }
}

new Index()